@import '../styles/fonts.scss';
@import '../styles/deviceBreakpoints.scss';
@import '../styles/palette.scss';
@import './standards.module.scss';

.topToolbar {
  background-color: _palette(bg-primary) !important;
  border-bottom: $border-width solid #e3e4e5;
  justify-content: center;

  h1 {
    @include merriweather(20);
    padding-left: 0.5rem;

    @include target(tablet) {
      @include merriweather(16);
    }
  }

  h5,
  h6 {
    padding-left: 0.5rem;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;

    .flexRow {
      display: flex;
      align-items: center;
    }
  }

  .actions {
    flex-basis: auto;

    button {
      margin: 0.625rem;
    }
  }

  .title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: space-between;
  }

  .titleContainer {
    align-items: baseline;
    display: flex;
    padding-top: 0.3rem;
  }

  .titleDescription {
    @include barlow(14);
    padding-bottom: 0.3rem;
    padding-left: 0.5rem;

    @include target(tablet) {
      @include barlow(12);
    }
  }

  .titleActions {
    padding-left: 0.3rem;

    button {
      justify-content: left;
      min-width: 0.3rem;
      padding: 0;
      vertical-align: bottom;
    }
  }
}

.permanentMenuToolbar {
  @extend .topToolbar;
  left: calc(13rem + 1vw) !important; // Width of sidebar
  height: 4rem;
  width: calc(100% - 13rem - 2vw) !important;
}
